import { render, staticRenderFns } from "./Kardex-transfer.vue?vue&type=template&id=2db69920&scoped=true"
import script from "./kardex-transfer.js?vue&type=script&lang=js&external"
export * from "./kardex-transfer.js?vue&type=script&lang=js&external"
import style0 from "./Kardex-transfer.vue?vue&type=style&index=0&id=2db69920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db69920",
  null
  
)

export default component.exports